export function hasWebGLSupport() {
  try {
    const canvas = document.createElement("canvas");
    return (
      !!window.WebGLRenderingContext &&
      (!!canvas.getContext("webgl") ||
        !!canvas.getContext("experimental-webgl"))
    );
  } catch (e) {
    return false;
  }
}

export function hasHardwareAcceleration() {
  return drawStrokeOnCanvas(true) !== drawStrokeOnCanvas(false);
}

function drawStrokeOnCanvas(forceHwa) {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d", { willReadFrequently: forceHwa });
  ctx.moveTo(0, 0), ctx.lineTo(120, 121); // HWA is bad at obliques (https://stackoverflow.com/questions/6868011/javascript-detect-if-hardware-acceleration-is-enabled)
  ctx.stroke();
  return ctx.getImageData(0, 0, 200, 200).data.join();
}
